import { getConversationItems } from "./conversations"
import { conversationsKeys } from "./queryKeys"
import { useQuery } from "@tanstack/react-query"

export const useGetConversationsItemsQuery = (conversationId: string) => {
  return useQuery({
    queryKey: conversationsKeys.detail(conversationId),
    queryFn: () => getConversationItems(conversationId),
  })
}
